import React from 'react';
import cc from 'classcat';
import styles from './styles.module.scss';
import { EmailButton } from '../../index';

interface Props {
  consultant: Maybe<ConsultantsFragment>[] | ConsultantsFragment;
  locationTitle: string;
}

const ConsultantCard = ({ consultant, locationTitle }: Props) => {
  // Handle both array and single object
  const consultantData = Array.isArray(consultant) ? consultant[0] : consultant;

  if (!consultantData) return null;

  const imageUrl = consultantData?.image?.[0]?.url;
  const hasImage = !!imageUrl;
  const firstName = consultantData?.title?.split(' ')?.[0] || consultantData?.title;

  return (
    <div className={cc([styles.consultantCard, hasImage && styles.withImage])}>
      {imageUrl && (
        <div className={styles.imageWrapper}>
          <img src={imageUrl} alt={consultantData.title || 'Consultant'} />
        </div>
      )}

      <div className={styles.content}>
        <h3 className={styles.name}>{consultantData.title}</h3>

        <p className={styles.description}>
          Interested in finding out more or booking a tour of {locationTitle}? Get in touch with {firstName}, our friendly consultant.
        </p>

        <div className={styles.buttons}>
          {consultantData.phone && (
              <a href={`tel:${consultantData.phone!.replace(/[^\d\+]/g, '')}`} title={'Click to call ' + firstName + ' to book a tour'} className={'newStyleButtonOverrideSolid'}>
                Call {firstName} to book a tour
              </a>
          )}

         <EmailButton section="Retirement Village Location" name={locationTitle!} />
        </div>
      </div>
    </div>
  );
};

export default ConsultantCard;

